import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { CatMatch } from "@shared/models/common";
import { NgRedux } from "@shared/redux/redux-compatibility.service";
import { AppState } from "@shared/redux/store";
import { CatMatchPhraseMetadataModel } from "./model/cat-match-phrase-metadata.model";
import { CommonService } from "@shared/services/common.service";


@Component({
    selector: 'cat-match-phrase-metadata',
    templateUrl: './cat-match-phrase-metadata.component.html',
    styleUrls: ['./cat-match-phrase-metadata.component.scss'],
    standalone: false
})
export class CatMatchPhraseMetadataComponent implements OnChanges {
    

    @Input() catMatch: CatMatch;

    @Input() multiValuesSeparator = ",";

    @Output() changeLoadingState = new EventEmitter<boolean>();

    constructor( private ngRedux: NgRedux<AppState>, 
        private commonService: CommonService,
    ) {

    }
    showMetadata = true;
    displayMetadata = true;
    
    ngOnChanges(changes: SimpleChanges): void {
        
        let currRevDoc = this.ngRedux.getState().curRevDoc;
        let catVersionId = currRevDoc.catVersionId;

        let phraseId = this.catMatch.catPhrase.phraseId;
        this.changeLoadingState.emit(true);
        this.catMatchedPhrasesMetadata = [];
        this.showMetadata = true;
        this.displayMetadata = false;
        this.commonService.getCatMatchPhraseMetadata(catVersionId, phraseId).subscribe({
            next: (matchedMetadata) => {

            this.changeLoadingState.emit(false);
            this.catMatchedPhrasesMetadata = matchedMetadata;
            this.displayMetadata = this.hasMetadataToDisplay();
        }, error: (err) => {
            
            this.changeLoadingState.emit(false);
            this.catMatchedPhrasesMetadata = undefined;
            this.displayMetadata = false;
        }});
    }
    hasMetadataToDisplay() {
        
            for (let i=0; i<this.catMatchedPhrasesMetadata?.length; i++) {
                if (this.catMatchedPhrasesMetadata[i].is_display_metadata) {
                    return true;
                }
            }
            return false;

    }
    catMatchedPhrasesMetadata: CatMatchPhraseMetadataModel[] = [];

}